// extracted by mini-css-extract-plugin
export var container = "Container-module--container--25788";